// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"9162":"css/app.6973","9819":"css/admin-app.6973"}[chunkId] + ".css";
};